// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__pkmck","modal":"styles_modal__7TiFL","close":"styles_close__pqhCG"};